import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/work/CrystalNetwork-Nuxt/CrystalNetwork-Nuxt/src/layouts/default.vue").then(m => m.default || m))
}